import { MODULE_KEY } from '@/constants/modules';
import { useHasWorkspaceModule } from './useHasWorkspaceModule';
import { useIsAssistantAvailable } from './useIsAssistantAvailable';

export function useIsVoiceAssistantAvailable(): boolean {
  const isAssistantAvailable = useIsAssistantAvailable();
  const hasVoiceModule = useHasWorkspaceModule(MODULE_KEY.voiceAssistant);
  return isAssistantAvailable && hasVoiceModule;
}
